'use client';

import { ReviewsOperationsProgressView } from '@/components/reviews-operations-progress/ReviewsOperationsProgressView';
import { useReviewsOperationsProgressController } from '@/components/reviews-operations-progress/use-reviews-operations-progress-controller';

const ReviewsOperationsProgress = () => {
    const { cards } = useReviewsOperationsProgressController();

    return <ReviewsOperationsProgressView cards={cards} />;
};

export default ReviewsOperationsProgress;
